import { EasternBoardPicture, EasternPanel, EasternPair, type EasternPiece, type EasternPoint } from './XiangqiRulePaper';
import './JanggiRulePaper.css';
const at=(f:number,r:number,glyph:string,first=true):EasternPiece=>({at:[f,r],glyph,first});
const palace={start:[3,0] as EasternPoint,files:3,ranks:3};
const horseCrop={start:[2,2] as EasternPoint,files:5,ranks:5};
const horseEnds:EasternPoint[]=[[2,3],[2,5],[3,2],[3,6],[5,2],[5,6],[6,3],[6,5]];
function Mate() {
  const pieces=[at(0,9,'車'),at(3,8,'車'),at(4,9,'漢',false),at(3,7,'士',false),at(5,7,'士',false),at(3,1,'楚'),
    ...[0,2,6,8].map(f=>at(f,6,'兵',false)),...[0,2,4,6,8].map(f=>at(f,3,'卒'))];
  return <figure className="janggi-mate"><EasternBoardPicture game="janggi" name="janggi-mate" pieces={pieces} targets={[[3,9],[4,8],[5,9]]}
    blocked={[[3,9],[4,8],[5,9]]} unit={22} label="9×10の全盤。川はなく、両九宮に斜線があります。楚の車が漢の王に王手をかけています。漢番ですが、どの駒を動かしても王手を解消できず、王手中のパスもできないので詰みです。"/>
    <figcaption>漢の王は王手を解消できません。</figcaption></figure>;
}
function PalaceMoves() {
  return <EasternPair game="janggi" name="janggi-palace">
    <EasternPanel caption="中央からは8方向へ1マス動けます。"><EasternBoardPicture game="janggi" name="janggi-king-center" crop={palace} pieces={[at(4,1,'楚')]}
      targets={[[3,0],[4,0],[5,0],[3,1],[5,1],[3,2],[4,2],[5,2]]} paths={[[[4,1],[3,2]]]}
      label="九宮の3×3。中央の楚は縦横と斜めの線に沿って1マス動けます。士も同じです。"/></EasternPanel>
    <EasternPanel caption="端からは線のある3方向へ1マス動けます。"><EasternBoardPicture game="janggi" name="janggi-king-corner" crop={palace} pieces={[at(3,0,'楚')]}
      targets={[[4,0],[3,1],[4,1]]} paths={[[[3,0],[4,1]]]} label="左と同じ3×3、24単位の間隔。九宮の左下隅の楚は、縦横と中央への斜線に沿う3方向だけに1マス動けます。士も同じです。"/></EasternPanel>
  </EasternPair>;
}
function ChariotMoves() {
  const crop={start:[1,1] as EasternPoint,files:7,ranks:7};
  return <>
    <figure className="janggi-atlas-wide"><EasternBoardPicture game="janggi" name="janggi-chariot-straight" crop={crop} unit={18} pieces={[at(4,4,'車'),at(4,6,'卒')]}
      paths={[[[4,4],[1,4]],[[4,4],[7,4]],[[4,4],[4,1]],[[4,4],[4,5]]]} targets={[[1,4],[7,4],[4,1],[4,5]]} blocked={[[4,7]]}
      label="7×7の範囲。車は空いている縦横の線を何マスでも進みます。途中の卒は飛び越せません。"/>
      <figcaption>縦横に何マスでも動けます。駒は飛び越せません。</figcaption></figure>
    <figure className="janggi-palace-single"><EasternBoardPicture game="janggi" name="janggi-chariot-diagonal" crop={palace} pieces={[at(3,0,'車')]}
      paths={[[[3,0],[4,1],[5,2]]]} targets={[[4,1],[5,2]]} label="自分の九宮3×3。車は空いた斜線に沿って、中央にも反対の隅にも動けます。"/>
      <figcaption>九宮の斜線に沿っても進めます。</figcaption></figure>
  </>;
}
function CannonMoves() {
  const cases=[{name:'valid',screen:'卒',target:'士',caption:'間の卒1枚を越え、相手の士を取れます。'},
    {name:'no-screen',screen:null,target:'士',caption:'間に駒がなく、動けません。'},
    {name:'screen-cannon',screen:'包',target:'士',caption:'包は飛び越せません。'},
    {name:'target-cannon',screen:'卒',target:'包',caption:'相手の包は取れません。'}];
  return <>
    <div className="janggi-pair janggi-cannon-grid" data-eastern-comparison="janggi-cannon-palace">
      {cases.map(({name,screen,target,caption})=><EasternPanel key={name} caption={caption}>
        <EasternBoardPicture game="janggi" name={`janggi-cannon-${name}`} crop={palace} pieces={[at(3,0,'包'),at(5,2,target,false),...(screen?[at(4,1,screen)]:[])]}
          paths={name==='valid'?[[[3,0],[4,1],[5,2]]]:[]} blocked={name==='valid'?[]:[[5,2]]}
          label={`同じ3×3の九宮、同じ24単位の間隔。${caption}`}/>
      </EasternPanel>)}
    </div>
    <figure className="janggi-cannon-row"><EasternBoardPicture game="janggi" name="janggi-cannon-empty-landing" crop={{start:[0,3],files:7,ranks:3}} unit={22}
      pieces={[at(0,4,'包'),at(3,4,'卒')]} paths={[[[0,4],[6,4]]]} targets={[[6,4]]}
      label="7×3の範囲。包が卒1枚を越えて、横の空いた交点へ進みます。取らない移動でも、間の駒がちょうど1枚必要です。"/>
      <figcaption>駒を取らないときも、必ず1枚を飛び越えます。</figcaption></figure>
  </>;
}
function HorseMoves() {
  return <EasternPair game="janggi" name="janggi-horse">
    <EasternPanel caption="縦横1マスと斜め1マスを1手で進みます。"><EasternBoardPicture game="janggi" name="janggi-horse-clear" crop={horseCrop} pieces={[at(4,4,'馬')]}
      targets={horseEnds} paths={[[[4,4],[4,5],[3,6]],[[4,4],[5,4],[6,5]]]}
      label="5×5の範囲。馬は縦横1マスと斜め1マスをつないで1手で進みます。途中は空いていて、8方向へ動けます。"/></EasternPanel>
    <EasternPanel caption="途中の駒で、2方向が塞がれます。"><EasternBoardPicture game="janggi" name="janggi-horse-blocked" crop={horseCrop}
      pieces={[at(4,4,'馬'),at(4,5,'卒')]} targets={horseEnds.filter(p=>p[1]!==6)} blocked={[[3,6],[5,6]]}
      label="左と同じ5×5、24単位の間隔。馬のすぐ前に卒があり、その交点を通る2方向には動けません。"/></EasternPanel>
  </EasternPair>;
}
function ElephantMoves() {
  const crop={start:[1,1] as EasternPoint,files:7,ranks:7},ends:EasternPoint[]=[[1,2],[1,6],[2,1],[2,7],[6,1],[6,7],[7,2],[7,6]];
  return <EasternPair game="janggi" name="janggi-elephant">
    <EasternPanel caption="縦横1マスと斜め2マスを1手で進みます。"><EasternBoardPicture game="janggi" name="janggi-elephant-clear" crop={crop} unit={18}
      pieces={[at(4,4,'象')]} targets={ends} paths={[[[4,4],[4,5],[5,6],[6,7]],[[4,4],[5,4],[6,5],[7,6]]]}
      label="7×7の範囲。象は縦横1マスと斜め2マスをつないで1手で進みます。途中の2交点は空いていて、8方向へ動けます。"/></EasternPanel>
    <EasternPanel caption="途中のどちらかに駒があれば、進めません。"><EasternBoardPicture game="janggi" name="janggi-elephant-blocked" crop={crop} unit={18}
      pieces={[at(4,4,'象'),at(5,6,'卒')]} targets={ends.filter(p=>p[0]!==6||p[1]!==7)} blocked={[[6,7]]}
      label="左と同じ7×7、18単位の間隔。右上へ進む象の経路の2番目の途中の交点に卒があり、そこを通る経路では動けません。"/></EasternPanel>
  </EasternPair>;
}
function SoldierMoves() {
  return <EasternPair game="janggi" name="janggi-soldier">
    <EasternPanel caption="前か横へ1マス動けます。"><EasternBoardPicture game="janggi" name="janggi-soldier-normal" crop={horseCrop} pieces={[at(4,4,'卒')]}
      targets={[[4,5],[3,4],[5,4]]} paths={[[[4,4],[4,5]]]} blocked={[[4,3]]}
      label="5×5の範囲。卒は前か横へ1マス動けます。後ろには動けません。"/></EasternPanel>
    <EasternPanel caption="相手の九宮では斜線に沿って斜め前へも1マス動けます。"><EasternBoardPicture game="janggi" name="janggi-soldier-palace" crop={{start:[2,5],files:5,ranks:5}}
      pieces={[at(3,7,'卒')]} targets={[[3,8],[2,7],[4,7],[4,8]]} paths={[[[3,7],[4,8]]]} blocked={[[3,6]]}
      label="左と同じ5×5、24単位の間隔。相手の九宮に入った卒は、線のある斜め前へも1マス動けます。後ろには動けません。"/></EasternPanel>
  </EasternPair>;
}
function InitialScore() {
  const pieces:EasternPiece[]=[];
  for(const [rank,first,kingRank] of [[0,true,1],[9,false,8]] as const) {
    ['車','馬','象','士','', '士','象','馬','車'].forEach((glyph,f)=>{if(glyph)pieces.push(at(f,rank,glyph,first));});
    pieces.push(at(4,kingRank,first?'楚':'漢',first));
    for(const f of [1,7])pieces.push(at(f,first?2:7,'包',first));
    for(const f of [0,2,4,6,8])pieces.push(at(f,first?3:6,first?'卒':'兵',first));
  }
  return <figure className="janggi-score-board"><EasternBoardPicture game="janggi" name="janggi-score-initial" pieces={pieces} unit={22}
    label="9×10の初期盤。二人が続けてパスした後も盤上の32枚は変わりません。楚の駒は72点、漢の駒も72点ですが漢に1.5点を足すので73.5点となり、漢の勝ちです。"/>
    <figcaption>二人が続けてパスした後は漢の勝ちです。</figcaption>
    <div className="janggi-score-values"><span>楚 <strong>72点</strong></span><span>漢 <strong>73.5点</strong></span></div>
  </figure>;
}
function Bikjang() {
  return <div className="janggi-full-stack" data-eastern-comparison="janggi-bikjang">
    <EasternPanel caption="王を横へ動かして、続けます。"><EasternBoardPicture game="janggi" name="janggi-bikjang-clear" unit={22}
      pieces={[at(4,1,'楚'),at(4,8,'漢',false),at(0,3,'車'),at(8,6,'車',false)]} paths={[[[4,1],[3,1]]]} targets={[[3,1]]}
      label="9×10の全盤。楚と漢の王が同じ縦の線で向かい合い、間に駒がありません。次の楚番で王を横へ動かしてビッチャンを解けば続行できます。"/></EasternPanel>
    <EasternPanel caption="パスして、点数で決着します。"><EasternBoardPicture game="janggi" name="janggi-bikjang-pass" unit={22}
      pieces={[at(4,1,'楚'),at(4,8,'漢',false),at(0,3,'車'),at(8,6,'車',false)]}
      label="左と同じ9×10、22単位の間隔、同じ盤。次の楚番でパスしてビッチャンを解かなければ、楚13点、漢14.5点で漢が勝ちます。"/></EasternPanel>
  </div>;
}
export function JanggiRulePaper() {
  return <article className="rule-paper janggi-paper">
    <div data-janggi-primary className="janggi-primary">
      <section><h2>相手の王を詰ませると勝ちです。</h2>
        <p>王への攻撃を王手といいます。相手が王手を解消できない状態が詰みです。</p><Mate/></section>
      <section className="janggi-start"><p>楚側から交互に自分の駒を1枚ずつ動かします。駒は盤の交点に置きます。</p>
        <p>自分の王が王手になる手は指せません。</p></section>
    </div>
    <div className="janggi-details">
      <section data-janggi-detail="palace"><h3>王と士は自陣の3×3（九宮）から出られません。</h3><PalaceMoves/>
        <p>取った駒はもう使えません。駒は成りません。</p></section>
      <section data-janggi-detail="chariot"><h3>車は縦横と九宮の斜線に沿って動けます。</h3><ChariotMoves/></section>
      <section data-janggi-detail="cannon"><h3>包は必ず1枚を飛び越えます。</h3><p>縦横に何マスでも動けます。九宮の斜線に沿っても動けます。</p>
        <p>間の1枚は自分の駒でも相手の駒でもかまいません。包は飛び越せず、相手の包も取れません。</p><CannonMoves/></section>
      <section data-janggi-detail="horse"><h3>馬は縦横1マスと斜め1マスをつないで進みます。</h3><HorseMoves/><p>途中の1交点は空いている必要があります。</p></section>
      <section data-janggi-detail="elephant"><h3>象は縦横1マスと斜め2マスをつないで進みます。</h3><ElephantMoves/><p>途中の2交点はどちらも空いている必要があります。</p></section>
      <section data-janggi-detail="soldier"><h3>卒・兵は前か横へ1マス動けます。</h3><SoldierMoves/><p>後ろには動けません。</p></section>
      <section data-janggi-detail="pass"><h3>パスして、相手へ番を渡せます。</h3><p>王手を受けていなければ、駒を動かさずにパスできます。二人が続けてパスすると、点数で勝敗を決めます。</p></section>
      <section data-janggi-detail="bikjang"><h3>王どうしが向かい合う、ビッチャン。</h3>
        <p>王どうしが同じ縦の線に並び、間に駒がない状態です。次の手番の側が解けば続行し、解かなければ点数で勝敗を決めます。</p><Bikjang/></section>
      <section data-janggi-detail="score"><h3>盤に残った駒の点数を比べます。</h3>
        <div className="janggi-piece-scores">{[['車',13],['包',7],['馬',5],['象',3],['士',3],['卒・兵',2],['王',0]].map(([piece,score])=><span key={piece}>{piece} <b>{score}点</b></span>)}</div>
        <p>自分の駒の点数を合計し、漢側には1.5点を足します。点数の多い方が勝ちです。</p><InitialScore/>
        <p>駒の配置と手番が同じ局面が3回現れたときや、対局が200手を超えたときも、点数で勝敗を決めます。</p></section>
    </div>
  </article>;
}
